import BaseController from "../../controller/BaseController";
import AdminDataService from "../../util/AdminDataService";
import JSONModel from "sap/ui/model/json/JSONModel";
import { Button$PressEvent } from "sap/m/Button";
import { Dialog$AfterCloseEvent } from "sap/m/Dialog";
import Validator from "../../util/Validator";

/**
 * @namespace com.reply.leaviosa.controller
 */
export default class ContractController extends BaseController {
    private readonly DIALOG_ID = "DialogCreateUpdateContract";

    public async onInit(): Promise<void> {
        AdminDataService.getContracts();
    }

    //*************************************************************************************
    // EVENT HANDLERS
    //*************************************************************************************

    public async onCreateContract(): Promise<void> {
        this.getView().setModel(new JSONModel({}), "contract");
        await this.openDialog(this.DIALOG_ID);
    }

    public async onEdit(oEvent: Button$PressEvent): Promise<void> {
        const selectedContract = oEvent.getSource().getBindingContext("dataModel");
        this.getView().setModel(new JSONModel(selectedContract.getObject()), "contract");
        await this.openDialog(this.DIALOG_ID);
    }

    public async onSaveDialog(oEvent: Dialog$AfterCloseEvent): Promise<void> {

        const validator = new Validator();
        const valid = validator.validate(oEvent.getSource().getParent());
        if (!valid) return;

        const contractData = (this.getView().getModel("contract") as JSONModel).getData();

        if (contractData.id) {
            AdminDataService.updateContract(contractData);
        } else {
            AdminDataService.createContract(contractData);
        }

        this.destroyDialog(this.DIALOG_ID);
    }
}
